export enum BannerClassStatusEnum {
	Danger = 'vtmn-border-border-negative',
	Warning = 'vtmn-border-border-warning',
	Success = 'vtmn-border-border-positive',
	Information = 'vtmn-border-border-information'
}

// Values expected by the diwo-helper-api /banners endpoints (DIWO-5777), field `type`
export enum BannerApiClassEnum {
	Information = 'INFORMATION',
	Warning = 'WARNING',
	Danger = 'DANGER',
	Success = 'SUCCESS'
}

export enum BannerStyleStatusEnum {
	Danger = 'background-color: rgba(255, 0, 0, 0.102);',
	Warning = 'background-color: rgba(255, 165, 0, 0.102);',
	Success = 'background-color: rgba(0, 128, 0, 0.102);',
	Information = 'background-color: rgba(0, 112, 243, 0.102);'
}

export enum BannerIconStatusEnum {
	Danger = 'vtmx-close-circle-line vtmn-text-content-negative',
	Warning = 'vtmx-alert-line vtmn-text-content-warning',
	Success = 'vtmx-checkbox-circle-line vtmn-text-content-positive',
	Information = 'vtmx-information-line vtmn-text-content-information'
}
